"use strict";

import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom";
import { Router, browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { Provider } from "react-redux";
import configureStore from "./store";
import routes from "./routes";

require("../images/mapPin-primary.png");
require("../images/mapPin-secondary.png");

export default function configureClient(initialState, element = "app") {
  const store = configureStore(initialState);
  const history = syncHistoryWithStore(browserHistory, store);

  ReactDOM.render(
    <Provider store={store}>
      <Router routes={routes} history={history} />
    </Provider>,
    document.getElementById(element)
  );

  document.body.className += " is-ready";
}



// WEBPACK FOOTER //
// ./assets/shared/client.jsx